import { SharedModule } from "@/shared/shared.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NotificationTemplateListComponent } from "./notification-template-list.component";
import { NotificationTemplateDialogComponent } from "./notification-template-dialog.component";
import { NotificationTemplateFinderDialog } from "./notification-template-finder.dialog";
import { TemplatePreviewDialogComponent } from "./template-preview-dialog.component";

export const routes = [];

@NgModule({
  declarations: [NotificationTemplateListComponent, NotificationTemplateDialogComponent, NotificationTemplateFinderDialog,
    TemplatePreviewDialogComponent],
  imports: [CommonModule, SharedModule],
})
export class NotificationsModule { }
